import Plausible from 'plausible-tracker'

const { trackPageview, trackEvent } = Plausible({
  trackLocalhost: false,
  domain: process.env.PLAUSIBLE_DOMAIN || 'weekly.globe-groupe.com',
})

export { trackPageview, trackEvent }
